"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AreYouSureModalState_1 = require("./AreYouSureModalState");
/** Platform UI Components */
var Button_1 = require("@idp/ui-components/components/atoms/Button");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var Modal_1 = require("@idp/ui-components/components/atoms/Modal");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
// import { AreYouSureModalCms } from './AreYouSureModal.cms';
/** Stylesheets */
var globalStyles = require("../../../../../../styles/att-global.scss");
var styles = require("./AreYouSureModal.scss");
/** LOB Components */
/** Api, Reporting, Mappers, Request, Response */
var ReportingService_1 = require("../../../../../../api/ReportingService");
var ReportingService_2 = require("../../../../../../api/ReportingService");
var AreYouSureModal = /** @class */ (function (_super) {
    __extends(AreYouSureModal, _super);
    // private AreYouSureModalCmsData: AreYouSureModalCms;
    function AreYouSureModal(props) {
        var _this = _super.call(this, props) || this;
        _this.reportingService = new ReportingService_1.default();
        _this.haveSentPageLoad = false;
        _this.state = new AreYouSureModalState_1.default();
        _this.initializeEvents();
        return _this;
    }
    AreYouSureModal.prototype.initializeEvents = function () {
        var _this = this;
        // this.AreYouSureModalCmsData = CMS.get(new AreYouSureModalCms(), 'AreYouSureModal').content;
        this.AreYouSureModalCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
        this.removeClickedEvent = {
            onClick: function () {
                _this.fireContinueEvent();
                _this.props.events.onModalComplete(true);
            },
        };
        this.cancelClickedEvent = {
            onClick: function () {
                _this.fireCancelEvent();
                _this.props.events.onModalComplete(false);
            },
        };
        this.removeSavedIDModalCloseEvent = {
            onClose: function () {
                _this.fireCancelEvent();
                _this.props.events.onModalComplete(false);
            },
        };
    };
    AreYouSureModal.prototype.fireCancelEvent = function () {
        this.reportingService.fireLinkClickEvent('Cancel', ReportingService_2.PageUrls.LOGIN_PAGE);
    };
    AreYouSureModal.prototype.fireContinueEvent = function () {
        this.reportingService.fireLinkClickEvent('Remove', ReportingService_2.PageUrls.LOGIN_PAGE);
    };
    AreYouSureModal.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.data.show && !this.haveSentPageLoad) {
            console.log('here');
            this.analyticsAreYouSureModalPageLoad();
        }
    };
    AreYouSureModal.prototype.analyticsAreYouSureModalPageLoad = function () {
        this.reportingService.firePageLoadEvent(ReportingService_2.PageUrls.REMOVE_SAVED_ID_ARE_YOU_SURE_MODAL, ReportingService_2.PageName.REMOVE_SAVED_ID_ARE_YOU_SURE_MODAL);
        this.haveSentPageLoad = true;
    };
    AreYouSureModal.prototype.render = function () {
        var idList = this.props.data.idsToDelete.map(function (id) {
            return (React.createElement("p", { key: id, className: [
                    globalStyles.formRowLg,
                    globalStyles.formRowBtmLg,
                ].join(' ') }, id));
        });
        return (React.createElement(Modal_1.default, { accessibilityText: this.AreYouSureModalCmsData.loginWidget.areYouSureModalTitle + 'Modal', options: {
                center: true,
                show: this.props.data.show,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM,
            }, events: this.removeSavedIDModalCloseEvent, testId: 'Removed_Saved_ID_Modal' },
            React.createElement("div", { className: [styles.loginAreYouSureModalWrapper].join(' ') },
                React.createElement("div", { className: [styles.modalHeader].join(' ') },
                    React.createElement("h1", null, this.AreYouSureModalCmsData.loginWidget.areYouSureModalTitle)),
                React.createElement("div", { className: [styles.modalContent].join(' ') },
                    React.createElement("p", null, this.AreYouSureModalCmsData.loginWidget.areYouSureModalContent),
                    idList),
                React.createElement("div", { className: [styles.modalFooter].join(' ') },
                    React.createElement("div", { className: [styles.ctaButtonGroup].join(' ') },
                        React.createElement(Button_1.default, { data: {
                                text: this.AreYouSureModalCmsData.loginWidget.areYouSureModalButtonPrimaryCTA,
                            }, events: this.removeClickedEvent, options: {
                                size: ButtonProps_1.ButtonSize.LARGE,
                            }, testId: 'Are_You_Sure_Modal_Button_Continue' }),
                        React.createElement(Button_1.default, { data: {
                                text: this.AreYouSureModalCmsData.loginWidget.areYouSureModalButtonSecondaryCTA,
                            }, events: this.cancelClickedEvent, options: {
                                size: ButtonProps_1.ButtonSize.LARGE,
                                type: ButtonProps_1.ButtonType.GHOST,
                            }, testId: 'Are_You_Sure_Modal_Button_Cancel' }))))));
    };
    return AreYouSureModal;
}(React.Component));
exports.default = AreYouSureModal;
//# sourceMappingURL=AreYouSureModal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/RemoveSavedID/AreYouSureModal/AreYouSureModal.js
// module id = 1510
// module chunks = 8